import React from 'react';
import PropTypes from 'prop-types';
import styles from './WmsButton.scss';

const rebrandedTypes = {
    blue: "primary",
    green: "primary",
    yellow: "orange",
    black: "outlined"
}

class WmsButton extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            isHovering: false
        }
        this.handleMouseHover = this.handleMouseHover.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.buttonElement = null;
        this.hoverElements = {};
    }

    // Kendo windows append their content outside the root this tree was mounted
    // into, and React only delegates its own events within that root, so a button
    // inside a modal never sees the synthetic hover events. Listening natively
    // keeps the disabled tooltip working in both places.
    bindHoverListeners = (key, element) => {
        const previous = this.hoverElements[key];

        if (previous === element) {
            return;
        }

        if (previous) {
            previous.removeEventListener("mouseenter", this.handleMouseHover);
            previous.removeEventListener("mouseleave", this.handleMouseLeave);
        }

        this.hoverElements[key] = element;

        if (element) {
            element.addEventListener("mouseenter", this.handleMouseHover);
            element.addEventListener("mouseleave", this.handleMouseLeave);
        }
    }

    setDisabledOverlayRef = (element) => this.bindHoverListeners("overlay", element);

    setTooltipRef = (element) => this.bindHoverListeners("tooltip", element);

    setButtonRef = (element) => {
        if (this.buttonElement === element) {
            return;
        }

        if (this.buttonElement) {
            this.buttonElement.removeEventListener("click", this.handleClick);
        }

        this.buttonElement = element;

        if (this.buttonElement) {
            this.buttonElement.addEventListener("click", this.handleClick);
        }
    }

    handleClick = (event) => {
        if (!this.props.disabled && !this.props.loading) {
            this.props.onClickFunc(event);
        }
    }

    componentWillUnmount() {
        this.buttonElement?.removeEventListener("click", this.handleClick);
        this.setDisabledOverlayRef(null);
        this.setTooltipRef(null);
    }

    handleMouseHover() {
        this.setState({ isHovering: true });
    }

    handleMouseLeave() {
        this.setState({ isHovering: false });
    }

    render() {
        const mappedButtonType = rebrandedTypes[this.props.buttonType] ?? this.props.buttonType

        return (
            <div className={"wms-button-component " + this.props.parentClassName}>
                <div className={"button_holder " + (this.props.loading ? "disabled_button" : "")}>
                    <button
                        ref={this.setButtonRef}
                        id={this.props.id}
                        className={
                            (this.props.disabled == true ?
                                (this.props.showToolTip == true ?
                                    "wms_disabled_look" :
                                    "wms_button_disabled"
                                ) :
                                " ") + ' ' +
                            (this.props.icon == '' ? 'textSpace ' : ' ') +
                            'wms_toolbar_button ' + mappedButtonType + '_button_color' +
                            (this.props.icon != '' && this.props.iconPosition === 'after' ? ' icon-after-button' : '')
                        }
                        data-wms-selector={this.props.wmsSelector}
                        disabled={this.props.disabled}>
                        {this.props.loading ?
                            <div className="wms_sprite btnloader fa fa-spinner fa-spin"></div> :
                            this.props.icon != '' && this.props.iconPosition !== 'after' && (<div className={"wms_sprite fa " + this.props.icon}></div>)}
                        <div className={"wms_toolbar_button_text" +
                            (this.props.icon != '' && this.props.iconPosition === 'before' ? " icon-before" : "") +
                            (this.props.icon != '' && this.props.iconPosition === 'after' ? " icon-after" : "")
                        }>{this.props.label}</div>
                        {this.props.loading ? null :
                            this.props.icon != '' && this.props.iconPosition === 'after' && (<div className={"wms_sprite fa " + this.props.icon}></div>)}
                    </button>

                    {
                        this.props.disabled == true &&
                        this.props.showToolTip == true &&
                        this.props.loading == false &&
                        (<div>
                            <div className="div_disable" ref={this.setDisabledOverlayRef}>&nbsp;</div>
                            {this.state.isHovering == true && (<div ref={this.setTooltipRef} className="wms-button-tooltip">{this.props.tooltipText}</div>)}
                        </div>)
                    }
                </div>
            </div>
        );
    }

}
WmsButton.propTypes = {
    id: PropTypes.string, // this should write the id to the button
    buttonType: PropTypes.string, // ['green', 'yellow', 'red', 'black', 'blue']
    wmsSelector: PropTypes.string.isRequired, // this should set up a selector on the input
    label: PropTypes.string.isRequired,// thi should set label on button
    icon: PropTypes.string,// set icon in button
    iconPosition: PropTypes.oneOf(['before', 'after']), // position of icon relative to text
    disabled: PropTypes.bool, // disable button
    showToolTip: PropTypes.bool, // set tooltip show or not
    tooltipText: PropTypes.string, // show text on hover as tooltip
    loading: PropTypes.bool, // this pass loading true/false base on process runing or complete
    onClickFunc: PropTypes.func.isRequired, // this should control the onClick event and anything we need to determine before we send it up
}
WmsButton.defaultProps = {
    buttonType: 'primary',
    loading: false,
    showToolTip: false,
    disabled: false,
    tooltipText: 'set tooltip text',
    icon: '',
    iconPosition: 'before',
    parentClassName: ''
}
export default WmsButton;